export const enData = `
  <div class="paragraph">
    <div class="title">Who can join the Trade-In Programme?</div>
    <div class="text-box">
      <div class="text">The Trade-In Service is available to individuals aged 18 or older who legally reside in the United Kingdom.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What should I do before sending my old device?</div>
    <div class="text-box">
      <div class="text">Before sending your device:</div>
      <div class="text">• Erase all personal data and remove any PIN, password, or screen lock pattern</div>
      <div class="text">• Perform a full factory reset</div>
      <div class="text">• On iPhone: Disconnect your iCloud account by turning off "Find My iPhone"</div>
      <div class="text">• On Android: Remove your Google account (Settings > Accounts > Google > Remove account)</div>
      <div class="text">This ensures the device is not linked to your account and protects your personal information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How can I send my old device?</div>
    <div class="text-box">
      <div class="text">Packaging: Please use a sturdy, opaque box and sufficient protective material, such as bubble wrap, to protect your device during transit. Customers are responsible for ensuring that the device is securely packaged before handing it over to the courier.</div>
      <div class="text">Documentation: Print, fill out, and sign the Declaration of Ownership and Integrity and place it inside the package before sealing it.</div>
      <div class="text">Secure sealing: Make sure the package is securely closed and affix the free shipping label in a visible spot.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What types of devices are not accepted?</div>
    <div class="text-box">
      <div class="text">We do not accept devices that:</div>
      <div class="text">• are SIM-locked to a carrier;</div>
      <div class="text">• won’t power on or charge;</div>
      <div class="text">• cannot connect via Bluetooth or Wi-Fi;</div>
      <div class="text">• have internal component or motherboard failure;</div>
      <div class="text">• cannot take photos or record videos properly;</div>
      <div class="text">• have cracked lenses or severe structural damage;</div>
      <div class="text">• have malfunctioning buttons or stabilization issues;</div>
      <div class="text">• have been exposed to liquid or repaired/disassembled;</div>
      <div class="text">• are still linked to iCloud, Google, or any user account;</div>
      <div class="text">• are counterfeit or replicas;</div>
      <div class="text">• are severely damaged.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send accessories (charger, cable)?</div>
    <div class="text-box">
      <div class="text">Not mandatory but recommended. Including accessories contributes to sustainability and proper reuse.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I also need to send headphones?</div>
    <div class="text-box">
      <div class="text">No. For hygiene reasons, headphones will be discarded and not included in the evaluation.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send the purchase invoice?</div>
    <div class="text-box">
      <div class="text">It is not required for the evaluation or payment. You may keep it for your own records.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How do you evaluate my old device?</div>
    <div class="text-box">
      <div class="text">We use certified diagnostic software and carry out a manual inspection at our assessment centre to determine the condition of your device. Personal data is handled in accordance with the UK General Data Protection Regulation (UK GDPR) and the Data Protection Act 2018.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if the condition I indicated does not match your evaluation?</div>
    <div class="text-box">
      <div class="text">If there are differences between the condition you indicated and our evaluation, we will send you an email with:</div>
      <div class="text">• An updated offer based on the actual inspection</div>
      <div class="text">• The diagnostic report and the reasons for the difference</div>
      <div class="text">You may choose to accept or reject the offer:</div>
      <div class="text">• If you accept, the trade-in will be completed, and you will receive payment in your bank account within 3 business days.</div>
      <div class="text">• If you reject the revised offer, you may request the return of your device. A return shipping fee of up to GBP £19 (VAT included) will apply:</div>
      <div class="text">• The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.</div>
      <div class="text">• Payment details will be provided upon request or included in the payment link email.</div>
      <div class="text">• Once payment is confirmed (if applicable), Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What if I don’t respond to the updated offer?</div>
    <div class="text-box">
      <div class="text">If you do not respond within 7 calendar days, our customer service team will attempt to contact you. If we still do not receive a response within 30 calendar days from the date of notification, the revised offer will be treated as rejected and the return process will apply. A return shipping fee of up to GBP £19 (VAT included) may apply.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens to my personal data?</div>
    <div class="text-box">
      <div class="text">You are responsible for removing your personal data and performing a factory reset before sending your device. Any personal data identified during processing will be handled in accordance with our applicable data-erasure procedures and UK data protection requirements. We process personal data in accordance with the UK GDPR and the Data Protection Act 2018.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Who pays for shipping costs?</div>
    <div class="text-box">
      <div class="text">The initial shipping is always free.</div>
      <div class="text">If you reject the updated offer:</div>
      <div class="text">• A return shipping fee applies, up to a maximum of GBP £19 (VAT included).</div>
      <div class="text">• The fee must be paid within five (5) calendar days after receiving the payment request, using the official prepaid return label provided by Danghuan.</div>
      <div class="text">• Payment details will be provided upon request or included in the payment link email.</div>
      <div class="text">• Once payment is confirmed (if applicable), Danghuan will verify the transaction within five (5) business days and arrange the return shipment to your original address. You will be notified by email once the shipment has been dispatched, including the corresponding tracking information.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if my package is lost during shipping?</div>
    <div class="text-box">
      <div class="text">If your device is lost during transportation, Danghuan Europe S.L. will assist you with the courier’s official claim process.</div>
      <div class="text">A shipment is considered lost if it has not been tracked, confirmed, or received by Danghuan within 15 calendar days from handover to the courier.</div>
      <div class="text">• You must use the authorized prepaid shipping label provided by Danghuan; To be eligible for logistics protection, you must use the authorised prepaid shipping label provided by Danghuan. We cannot accept responsibility for devices sent using an alternative shipping method.</div>
      <div class="text">• Danghuan will assist with the courier investigation, which usually takes 30–60 days.</div>
      <div class="text">If the loss is confirmed under Danghuan’s logistics system and the authorized label was used, the compensation will not exceed the final appraised trade-in value of the device.</div>
      <div class="text">Approved payments will be transferred directly to the UK bank account provided during registration.</div>
      <div class="text">Note: Any compensation depends on the courier's policy.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">When will I receive the payment?</div>
    <div class="text-box">
      <div class="text">Once the final offer has been accepted, payment will be made by bank transfer within 3 working days. Please ensure that the UK bank account details provided during registration are correct and that the account is held in your name.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Is it mandatory to provide my Personal ID Number?</div>
    <div class="text-box">
      <div class="text">Yes, to process the payment, you must provide a valid Personal ID Number, without space or special characters, and it must match the IBAN account holder.</div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Can I cancel my Trade-In operation?</div>
    <div class="text-box">
      <div class="text">Yes, if your old device has not yet been paid for. Please contact us as soon as possible at <span class="email">oppo@danghuan.eu</span>. If your old device has been sent, please contact us in 48 hours, otherwise the recycling process will proceed normally.</div>
    </div>
  </div>
`;
